import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getAuthenticationConfig} from 'src/openapi/admin/apis/ClientConfigApi';
import {useAppDispatch} from 'src/store/hooks';

import {DEFAULT_AUTHENTICATION_CONFIG} from './authentication-context';

export const useAuthenticationConfig = () => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getAuthenticationConfig(),
    ), [apiDispatch]);

    return useReadOnlyDataHook({getDispatchAction, initValue: DEFAULT_AUTHENTICATION_CONFIG});
};
